/**
 * Firebase Token Adapter
 *
 * Implementation of AuthTokenProvider that uses Firebase Auth.
 * This adapter encapsulates all Firebase-specific logic for token retrieval.
 *
 * This is the only place where Firebase auth is used for API token management.
 * The API client uses the abstract AuthTokenProvider interface instead.
 */

import { auth } from '@/shared/config/firebase';
import type { AuthTokenProvider } from '@/shared/api/auth-token-provider';

export const firebaseTokenAdapter: AuthTokenProvider = {
  async getToken(): Promise<string | null> {
    const user = auth.currentUser;
    if (!user) return null;
    // Force refresh to ensure token is valid
    return user.getIdToken(true);
  },
};
